import React, { useEffect, useState } from "react";
import Classes from "./styles/style.module.css";
import FooterItem from "./FooterItem";
import { useSelector, useDispatch } from "react-redux";
import appApi from "../../utils/AppApi";
import { setNewBlog } from "../../redux/actions/Blog";

const MainFooter = () => {
  const { newBlog } = useSelector(({ blog }) => blog);
  const dispatch = useDispatch();
  const [lastBlogId, setLastBlogId] = useState("");

  useEffect(() => {
    checkHasLast();
  }, []);

  const checkHasLast = async () => {
    try {
      await appApi.get(`/blog/last`).then(({ data }) => {
        if (data) {
          dispatch(setNewBlog(true));
          setLastBlogId(data.data._id);
        } else {
          dispatch(setNewBlog(false));
        }
      });
    } catch (error) {
      if (error.response) {
        console.log(error);
      }
    }
  };

  return (
    <div className={Classes.mainFooterContainer}>
      <div className={Classes.footerContainer}>
        <FooterItem route={"/"} />
        <FooterItem route={"/dashboard"} />
        <FooterItem route={"/blog"} hasNew={false} id={lastBlogId} />
        <FooterItem route={"/profile"} />
      </div>
    </div>
  );
};

export default MainFooter;
